<script>
import Properties from "@/components/widgets/property-list.vue";
import Clients from "@/components/widgets/client-list.vue";
import Employees from "@/components/widgets/employee-list.vue";
import { required } from "vuelidate/lib/validators";
import Multiselect from "vue-multiselect";

export default {
  props: {
    campus: {
      type: Number,
      default: 0,
    },
  },
  components: {
    Properties,
    Clients,
    Employees,
    Multiselect,
  },
  data() {
    return {
      referenceModal: {
        type: "",
        show: false,
        title: "",
        size: null,
      },
      newSubsidiaryLedger: {
        id: 0,
        title: "",
        description: "",
        accountId: null,
        type: null,
        referenceId: "",
        referenceType: "",
      },
      accounts: [],
      SLTypes: [
        { value: null, text: "Select Subsidiary Ledger Type....", disabled: true },
        { value: "Receivable", text: "Accounts Receivable" },
        { value: "Payable", text: "Accounts Payable" },
        { value: "Inventory", text: "Inventory" },
        { value: "PPE", text: "Property Plant and Equipment" },
        { value: "TR", text: "Trust Receipt" },
        { value: "ICS", text: "Inventory Custodian Slip" },
      ],
      selectedReference: null,
      submitted: false,
    };
  },
  methods: {
    fetchAccounts() {
      this.$store
        .dispatch("accounts/getAllAccounts")
        .then((response) => {
          this.accounts = response.data
            .map((item) => ({
              value: item.id,
              uacs: item.uacs,
              accountName: item.accountName,
            }))
            .sort((a, b) => a.accountName.localeCompare(b.accountName));
        })
        .catch(() => {
          this.$swal({
            icon: "error",
            text: "Cannot fetch accounts. Please contact your administrator",
          });
        });
    },
    showReferenceModal(type) {
      this.referenceModal.type = type;
      this.referenceModal.show = true;
      this.referenceModal.title = "Select Reference";
      this.referenceModal.size = "xl";
    },
    getProperty(data) {
      this.selectedReference = data;
      this.newSubsidiaryLedger.referenceId = data.id;
      this.newSubsidiaryLedger.referenceType = data.type;
      this.referenceModal.show = false;
    },
    getClient(data) {
      this.selectedReference = data;
      this.newSubsidiaryLedger.referenceId = data.id;
      this.newSubsidiaryLedger.referenceType = data.type;
      this.referenceModal.show = false;
    },
    getEmployee(data) {
      this.selectedReference = data;
      this.newSubsidiaryLedger.referenceId = data.id;
      this.newSubsidiaryLedger.referenceType = data.type;
      this.referenceModal.show = false;
    },
    clearAll() {
      this.newSubsidiaryLedger = {
        id: 0,
        title: "",
        description: "",
        accountId: null,
        type: null,
        referenceId: "",
        referenceType: "",
      };
      this.selectedSubsidiaryLedger = null;
      this.selectedReference = null;
      this.$v.$reset();
      this.$emit("refreshSL");
    },
    closeModal() {
      this.$bvModal.hide("newSLModal");
      this.clearAll();
    },
    customLabel({ uacs, accountName }) {
      return `${uacs} - ${accountName}`;
    },
    removeClient() {
      this.$swal({
        title: "Are you sure?",
        text:
          "You are about to remove client/property from this subsidiary ledger. Do you want to continue?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        confirmButtonText: "Yes, remove it",
      }).then((result) => {
        if (result.isConfirmed) {
          this.newSubsidiaryLedger.referenceId = "";
        }
      });
    },
    onSubmit() {
      if (!this.newSubsidiaryLedger.referenceId) {
        return this.showToast("Pleaes select client before proceeding", "warning");
      }
      this.submitted = true;
      this.$v.$touch();
      if (this.$v.newSubsidiaryLedger.$invalid) {
        return;
      } else {
        const nData = JSON.parse(JSON.stringify(this.newSubsidiaryLedger));
        nData.accountId = this.newSubsidiaryLedger.accountId.value;
        this.$swal({
          title: "Are you sure?",
          text: "You are about to create subsidiary ledger. Do you want to continue?f",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#00cfe8;",
          cancelButtonColor: "#5c636a",
          confirmButtonText: "Yes, continue it!",
        }).then(async (result) => {
          if (result.isConfirmed) {
            this.pageLoader(true);
            const response = await this.$store.dispatch(
              "subsidiaryledger/createSubsidiaryLedger",
              {
                data: nData,
                campusId: this.campus,
              }
            );
            if (response.data.error) {
              this.pageLoader(false);
              return this.showToast(response.data.errorMessage, "error");
            }
            this.$emit("fetchRecord", response.data);
            this.$bvModal.hide("newSLModal");
            this.pageLoader(false);
          }
        });
      }
    },
  },
  validations: {
    newSubsidiaryLedger: {
      title: { required },
      accountId: { required },
      type: { required },
      // referenceId: { required },
    },
  },
  created() {
    this.fetchAccounts();
  },
};
</script>

<template>
  <div>
    <!-- New Record -->
    <b-modal
      title="Create New Subsidiary Ledger"
      id="newSLModal"
      hide-footer
      no-close-on-backdrop
      @hidden="clearAll"
      size="lg"
    >
      <b-form-group label="SL Type" class="mb-3">
        <b-form-select
          :options="SLTypes"
          class="form-select"
          @input="newSubsidiaryLedger.referenceId = ''"
          v-model="newSubsidiaryLedger.type"
          :class="{
            'is-invalid': submitted && $v.newSubsidiaryLedger.type.$error,
          }"
        ></b-form-select>
        <div
          v-if="submitted && $v.newSubsidiaryLedger.type.$error"
          class="invalid-feedback"
        >
          <span v-if="!$v.newSubsidiaryLedger.type.required"
            >This value is required.</span
          >
        </div>
      </b-form-group>
      <b-form-group label="Nature of Account" class="mb-3">
        <multiselect
          v-model="newSubsidiaryLedger.accountId"
          track-by="value"
          label="accountName"
          placeholder="Select account"
          :custom-label="customLabel"
          :options="accounts"
          :searchable="true"
          :multiple="false"
          :close-on-select="true"
          :class="{
            'is-invalid': submitted && $v.newSubsidiaryLedger.accountId.$error,
          }"
        >
          <div
            v-if="submitted && $v.newSubsidiaryLedger.accountId.$error"
            class="invalid-feedback"
          >
            <span v-if="!$v.newSubsidiaryLedger.accountId.required"
              >This value is required.</span
            >
          </div>
        </multiselect>
      </b-form-group>
      <b-form-group label="Title" class="mb-3">
        <b-form-input
          class="form-input"
          placeholder="Enter title..."
          v-model="newSubsidiaryLedger.title"
          :class="{
            'is-invalid': submitted && $v.newSubsidiaryLedger.title.$error,
          }"
        ></b-form-input>
        <div
          v-if="submitted && $v.newSubsidiaryLedger.title.$error"
          class="invalid-feedback"
        >
          <span v-if="!$v.newSubsidiaryLedger.title.required"
            >This value is required.</span
          >
        </div>
      </b-form-group>
      <b-form-group label="Description" class="mb-3">
        <b-form-textarea
          class="form-input"
          rows="3"
          v-model="newSubsidiaryLedger.description"
          placeholder="Enter Description..."
        ></b-form-textarea>
      </b-form-group>

      <b-button
        variant="success"
        class="mb-3 me-2"
        @click="showReferenceModal('property')"
        ><i class="bx bx-search-alt align-middle font-size-18 me-2"></i>
        <span class="align-middle">Search Property</span></b-button
      >

      <b-button variant="info" class="mb-3 me-2" @click="showReferenceModal('client')"
        ><i class="bx bx-search-alt font-size-18 align-middle me-2"></i
        ><span class="align-middle">Search Client</span></b-button
      >
      <b-button
        variant="warning"
        class="mb-3 me-2"
        @click="showReferenceModal('employee')"
        ><i class="bx bx-search-alt font-size-18 align-middle me-2"></i
        ><span class="align-middle">Search Employee</span></b-button
      >

      <div
        class="row mb-1 mt-2"
        v-if="selectedReference && newSubsidiaryLedger.referenceId"
      >
        <div class="col-md-2">
          <span>Account for: </span>
        </div>
        <div class="col-md-10">
          <p class="mb-0">
            <span class="text-warning align-middle">{{
              selectedReference.name ? selectedReference.name : "Not indicated"
            }}</span>
            <i
              class="bx bx-trash me-2 align-middle ms-2 text-danger font-size-16"
              title="Remove this client"
              role="button"
              @click="removeClient"
            ></i>
          </p>
          <p class="mb-0">
            <i class="bx bx-map-pin me-2 align-middle text-info font-size-18"></i>
            <span>{{
              selectedReference.addressPosition
                ? selectedReference.addressPosition
                : "Not indicated"
            }}</span>
          </p>
          <span>
            <i class="bx bx-phone-call me-2 align-middle text-info font-size-18"></i>
            <span>{{
              selectedReference.contactNumber
                ? selectedReference.contactNumber
                : "Not indicated"
            }}</span>
          </span>
          <span class="ms-3">
            <i class="bx bx-mail-send me-2 align-middle text-info font-size-18"></i>
            <span>{{
              selectedReference.email ? selectedReference.email : "Not indicated"
            }}</span>
          </span>
        </div>
      </div>

      <div class="modal-footer mb-0 pb-0">
        <b-button variant="info" @click="onSubmit">
          <i class="bx bx-save me-2 align-middle"></i>
          <span class="align-middle">{{
            newSubsidiaryLedger.id > 0 ? "Update" : "Create"
          }}</span>
        </b-button>
        <b-button variant="link" @click="closeModal">Cancel</b-button>
      </div>
    </b-modal>
    <!-- New Record -->
    <!-- Reference modal -->
    <b-modal
      v-model="referenceModal.show"
      :title="referenceModal.title"
      :size="referenceModal.size"
      hide-footer
      no-close-on-backdrop
      no-close-on-escape
    >
      <Properties @fetchprop="getProperty" v-if="referenceModal.type === 'property'" />
      <Clients @fetchclient="getClient" v-if="referenceModal.type === 'client'" />
      <Employees @fetchemployee="getEmployee" v-if="referenceModal.type === 'employee'" />
    </b-modal>
  </div>
</template>
